module.exports = __webpack_public_path__ + "static/media/rolexGmtAvatar.a3fc3765.png";